import { render } from "./ChangeCategoryTable.vue?vue&type=template&id=8292dfd0"
import script from "./ChangeCategoryTable.vue?vue&type=script&lang=js"
export * from "./ChangeCategoryTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__